"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Toggleable = function Toggleable(props) {
  var children = props.children,
      show = props.show;

  if (show) {
    return _react.default.createElement(_react.default.Fragment, null, children);
  }

  return _react.default.createElement(_react.default.Fragment, null);
};

Toggleable.defaultProps = {
  show: true
};
Toggleable.propTypes = {
  children: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.string]).isRequired,
  show: _propTypes.default.bool
};
var _default = Toggleable;
exports.default = _default;